import * as ReactDOMClient from 'react-dom/client';
import {MeetingAppProvider} from './eventSlotSelectionApp.store';
import EventSlotSelectionApp from './eventSlotSelectionApp';

function initEventSelector() {
  const eventSelectorElement = document.getElementById('eventSelector');
  if (eventSelectorElement) {
    const eventId = parseInt(eventSelectorElement.dataset.eventId);
    const orderEntryId = isNaN(parseInt(eventSelectorElement.dataset.orderEntryId))
      ? undefined
      : parseInt(eventSelectorElement.dataset.orderEntryId);
    const adminOrderId = isNaN(parseInt(eventSelectorElement.dataset.adminOrderId))
      ? undefined
      : parseInt(eventSelectorElement.dataset.adminOrderId);
    const nextOccurrence = new Date(eventSelectorElement.dataset?.eventNextOccurrence);

    const root = ReactDOMClient.createRoot(eventSelectorElement);
    root.render(
      <MeetingAppProvider>
        <EventSlotSelectionApp
          eventId={eventId}
          orderEntryId={orderEntryId}
          adminOrderId={adminOrderId}
          nextOccurrence={nextOccurrence}
        />
      </MeetingAppProvider>
    );
  }
}

initEventSelector();
document.addEventListener('modal:loaded', () => {
  initEventSelector();
});
